<template>
  <div>
    <vm-table
        ref="vmTable"
        height="68vh"
        :filter.sync="filter"
        module="basic"
        url="applications/todo/my">
      <template slot="adSearch">
        <div class="vm-search">
          <el-radio-group v-model="filter.isread" style="margin-top: -20px;" @change="handleChange">
            <el-radio label="">全部</el-radio>
            <el-radio label="1">已读</el-radio>
            <el-radio label="0">未读</el-radio>
          </el-radio-group>
          <vm-search label="">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column
          prop="accessory"
          label=""
          :render-header="renderHeader1"
          width="50"
          align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.accessory === '1'">
            <i class="el-icon-paperclip"/>
          </span>
        </template>
      </el-table-column>
      <el-table-column
          prop="read"
          label=""
          :render-header="renderHeader2"
          width="50"
          align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.read === '0'">
            <i class="el-icon-message"/>
          </span>
        </template>
      </el-table-column>
      <el-table-column
          prop="untreadedTimes"
          label=""
          :render-header="renderHeader3"
          width="50"
          align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.untreadedTimes > 0">
            <i class="el-icon-refresh-left"/>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="sequID" label="主键" width="80"/>
      <el-table-column prop="billNO" label="编号" width="110">
        <template slot-scope="scope">
          <a @click="gotoApprove(scope.row)">{{scope.row.billNO}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="customerName" label="客户名称"/>
      <el-table-column prop="creatorName" label="制单人" width="100"/>
      <el-table-column prop="submitDate" label="提交时间"/>
      <el-table-column prop="statusName" label="状态" width="120"/>
      <el-table-column prop="descrpt" label="节点名称" width="120"/>
      <el-table-column prop="timeOut" label="是否超时" width="110">
        <template slot-scope="scope">
          <span v-if="scope.row.timeOut">
            {{scope.row.timeOutCount}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createdTime" label="上节点处理时间"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "BusinessApplication",
    components: {VmTable, VmSearch},
    data() {
      return {
        filter: {
          billType: 3,
          isread: "",
          filter: "",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleChange() {
        this.getList(1);
      },
      gotoApprove(row) {
        this.$router.push({
          path: "/approval",
          query: {
            billType: 3,
            billId: row.billID,
            sequId: row.sequID,
            $tabName: "审批_" + row.billNO,
          },
        });
      },
      renderHeader1(h,{column}) {
        return h(
          "span",
          [
            h("span", column.label),
            h("i", {
              class:"el-icon-paperclip",
              style:"color:#444444; font-size: 16px;",
            }),
          ],
        );
      },
      renderHeader2(h,{column}) {
        return h(
          "span",
          [
            h("span", column.label),
            h("i", {
              class:"el-icon-message",
              style:"color:#444444; font-size: 16px;",
            }),
          ],
        );
      },
      renderHeader3(h,{column}) {
        return h(
          "span",
          [
            h("span", column.label),
            h("i", {
              class:"el-icon-refresh-left",
              style:"color:#444444; font-size: 16px;",
            }),
          ],
        );
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
